import { AuthenticationModule } from './../authentication/authentication.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderRoutingModule } from './order-routing.module';
import { OrderFormComponent } from './components/order-form/order-form.component';
import { Redirect } from 'app/order/components/redirect/redirect';
import { OrderFormComponentV2 } from './components/order-form-v2/order-form-v2.component';
import { OrderFormComponentV3 } from './components/order-form-v3/order-form-v3.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';

@NgModule({
    declarations: [
        OrderFormComponentV2,
        OrderFormComponentV3,
        OrderFormComponent,
        Redirect
    ],
    imports: [
        // AuthenticationModule,
        CommonModule,
        OrderRoutingModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,
        CreditCardDirectivesModule
    ]

})
export class OrderModule { }
